import { Plug } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { mcpWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  mcpWeb,
  {
    McpServersPage: () => import('./McpServersPage'),
    McpAttachmentPicker: () => import('./McpAttachmentPicker'),
    McpAttachmentSummary: () => import('./McpAttachmentSummary'),
    McpMentionProvider: () => import('./McpMentionProvider'),
    McpMentionCreate: () =>
      import('./McpMentionCreate').then((m) => ({ default: m.McpMentionCreate })),
    McpDetailSection: () => import('./McpDetailSection'),
    McpPreview: () => import('./McpPreview').then((m) => ({ default: m.McpPreview })),
    McpServersPagePreview: () =>
      import('./McpServersPagePreview').then((m) => ({ default: m.McpServersPagePreview })),
  },
  {
    icons: { Plug },
  },
);
